import Hero from "../components/Hero";
import Services from "../components/Services";
import Partners from "../components/Partners";
import TopSection from "../components/assets/TopSection";

const Home = () => {
  return (
    <div>
      <div>
        <TopSection />
        <Hero />
        <Services />
        <Partners />
      </div>
    </div>
  );
};

export default Home;
